import React, { useEffect, useState, useRef } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { Icon } from "@iconify/react";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a18,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
  a191,
  a723,
  a724,
  a725
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "Components/Other Functions/AlertMessage";
import style from "./AddCategoryNew.module.css";
import { Box } from "@mui/material";
import Customertable from "Components/support/customervendor/customer";
import toast from "react-hot-toast";

export default function AddCategoryNew() {
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [allCategoryData, setAllCategoryData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
 


  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleReset = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      }
      //  else {
      //   if (submitButtonRef.current) {
      //     submitButtonRef.current.click(); // Safely trigger click
      //   } else {
      //     console.error("Submit button ref is not available");
      //   }
      // }
    }
  };

  const handlenew = () => {
    setActive("AddNew");
  };

  const handleCLick = () => {
    setActive("List");

    console.log("Handle List clicked");
  };

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CategoryName: "",
    Description: "",
    ShortName: "",
    ParentCategory: "",
    Slug: "",
    Status: "",
    HSNCode: "",

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a725, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CategoryName: newCategory.CategoryName,
      Description: newCategory.Description,
      ShortName: newCategory.ShortName,
      ParentCategory: newCategory.ParentCategory,
      Slug: newCategory.Slug,
      Status: "Active",
      HSNCode: newCategory.HSNCode,
      EmployeeCode: employeeCode,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a723 : a724,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CategoryName: "",
        Description: "",
        ShortName: "",
        ParentCategory: "",
        Slug: "",
        Status: "",
        HSNCode: "",
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        // setMessageType("error");
        toast.error(data.message,{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Category Added Successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "CategoryName", label: "CategoryName", type: "read", priority: 1 },

    { key: "Description", label: "Description", type: "read", priority: 3 },
    { key: "ShortName", label: "ShortName", type: "read", priority: 4 },
    {
      key: "ParentCategory",
      label: "ParentCategory",
      type: "read",
      priority: 5,
    },
    { key: "SlugStatus", label: "SlugStatus", type: "read", priority: 6 },

    {
      key: "HSNCode",
      label: "HSNCode",
      type: "read",
      priority: 7,
    },
  ];

  console.log("active", active);

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Category"}
          companyName={"Loyalstring"}
          module={"Product Masters"}
          page={"Category"}
        />

        <div style={{ padding: "16px" }}>
          {active == "List" ? (
            <>
              <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                     
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

              <Customertable
                columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                searchInput={searchInput}
                setSearchInput={setSearchInput}

                // title={"All Customers"}
              />
            </>
          ) : (
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,2fr)",
                        columnGap: "30px",
                        margin: "0px 0px",
                        padding: "var(--Space-0, 0px) 24px",
                      }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>
                            Category Name<sup>*</sup>
                          </label>
                          <input
                            name="CategoryName"
                            value={newCategory.CategoryName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style["addCategory-input"]}
                            ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          />
                          <label>Description</label>
                          <input
                            name="Description"
                            value={newCategory.Description}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style["addCategory-input"]}
                            ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                          />
                          <label>Short Name</label>
                          <input
                            name="ShortName"
                            value={newCategory.ShortName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            maxLength={5}
                            minLength={0}
                            className={style["addCategory-input"]}
                            ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                          />
                          <label>
                            Parent Category<sup>*</sup>
                          </label>
                          <select
                            name="ParentCategory"
                            value={newCategory.ParentCategory}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style["addCategory-input"]}
                            ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                          >
                            <option value={""}>Select an option</option>;
                            <option value={"Metal"}>Metal</option>;
                            <option value={"Non Metal"}>Non Metal</option>;
                          </select>
                          <label>Slug</label>
                          <input
                            name="Slug"
                            value={newCategory.Slug}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style["addCategory-input"]}
                            ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                          />
                          <label>HSN Code</label>
                          <input
                            name="HSNCode"
                            value={newCategory.HSNCode}
                            onChange={handleNewCategoryChange}
                            type="number"
                            className={style["addCategory-input"]}
                            ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, null)}
                          />
                        </div>
                      </Box>
                    </div>
                    <div className={style["btn-container"]}>
                      <button>
                        <Icon width="24px" icon="ic:sharp-check" /> Submit
                      </button>
                      <button
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #0077D4",
                          color: "#0077D4",
                        }}
                        onClick={handleReset}
                        id="reset-button"
                      >
                        <Icon width="24px" icon="ix:reset" /> Reset
                      </button>
                      <button onClick={handleCLick}>
                        <Icon width="24px" icon="fluent:list-rtl-16-filled" />{" "}
                        List
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
